<template>
    <div class="ges">
        <div class="ges__wrap r" @click="$emit('next')">
            <div class="ges__edit">
                <Icon name="sp/ui/icon-edit" />
            </div>
            <h3 class="ges__goal type--h3--default">{{ siloData.user.modules['meta_goals_goal'] }}</h3>
            <div class="ges__responses r">
                <div v-for="response in siloData.user.modules['meta_goals_responses']" class="ges__responses__item r">
                    <div class="type--h4--default">{{ response.question }}</div>
                    <div class="type--h5--detail">{{ response.answer }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from "@c/Icon.vue";
    export default {
        components: {
            Icon,
        },
        data() {
            return {
            }
        },
        props: {
            siloData: Object,
            instance: Object,
        },
    }
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.ges {
    background-color: var(--color-sp-cream);
    border: 1px solid var(--color-sp-border);
    padding: rem(16px) rem(20px) rem(40px);
    border-radius: rem(6px);
    &:hover, &:focus {
        cursor: pointer;
        border: 1px solid var(--color-sp-border-dark);
    }
}

.ges__wrap {
    gap: rem(20px);
}

.ges__edit {
    position: absolute;
    right: 0;
    top: 0;
}

.ges__goal {
    padding-right: rem(35px);
}

.ges__responses {
    > * + * {
        &:before {
            content: "";
            width: 100%;
            height: 1px;
            background-color: var(--color-sp-border);
            margin-block: rem(16px) rem(10px);
        }
    }

}

.ges__responses__item {
    gap: rem(6px);
}
</style>